import Vue from "vue";
import Router from "vue-router";
import layout from '@/views/layout/index'

Vue.use(Router);
export const route = [
    {
        path: '',
        redirect: '/index',
        component:layout,
        children:[
            {
                path:'index',
                component: ()=> import ('@/views/login/index'),
                name:'Login',
               // meta: { title: 'Сделки', icon: 'application', affix: true}
            },
        ]
    },
    //{ path: '*', redirect: '/index'}
]
// export default new Router({
//   mode: "history",
//   base: process.env.BASE_URL,
//   routes: route
// });
const router = new Router({
    mode: "history",
    base: process.env.BASE_URL,
    routes: route
})



export default router